module.exports = __webpack_public_path__ + "images/ca5bf19cdcae94bebbd3538b659fb615.svg";